import { useToast } from '@components/index'
import { apiClient } from '@services/api-client'
import { SNA_PREFIX } from '@services/utils'
import { useOnError } from '@services/utils/onError'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'

interface DeleteOfferProtocolParams {
  offerId: string
  protocolId: string
}

export function useDeleteOfferProtocol() {
  const toast = useToast()
  const { t } = useTranslation('toast')
  const queryClient = useQueryClient()
  const onError = useOnError()

  async function deleteProtocol({ offerId, protocolId }: DeleteOfferProtocolParams) {
    await apiClient.delete(`${SNA_PREFIX}offers/${offerId}/protocols/${protocolId}/`)
  }

  return useMutation({
    mutationFn: deleteProtocol,
    onSuccess: (_, variables) => {
      toast.success({ message: t('protocolDeleted') })
      queryClient.invalidateQueries({
        queryKey: ['offer-protocols', variables.offerId]
      })
    },
    onError
  })
}
